export enum ACTION {
  EDIT = "EDIT",
  DISABLE = "DISABLE",
  DISCONNECT = "DISCONNECT",
  ENABLE = "ENABLE",
  VIEW_CUSTOMERS = "VIEW_CUSTOMERS",
  EDIT_CUSTOMER = "EDIT_CUSTOMER",
  DISABLE_NAME = "DISABLE_NAME",
  ENABLE_NAME = "ENABLE_NAME",
}

export interface ILocation {
  country?: string;
  address?: string;
  isPrimary?: boolean;
}